import React, {useEffect, useState} from "react";
import Loading from "../../components/Loading/Loading";
import Button from "../../components/Button/Button";
import {useParams} from "react-router-dom";
import useOutgoingPaymentService from "../../api/services/useOutgoingPaymentService";
import OutgoingPaymentRow from "../../components/OutgoingPaymentRow/OutgoingPaymentRow";

const UserOutgoingPayments = () => {

  const {userShow} = useOutgoingPaymentService()
  const [outgoingPayments, setOutgoingPayments] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const {bookingId} = useParams()

  useEffect(() => {
    userShow(
      (outgoingPayments) => {
        setOutgoingPayments(outgoingPayments)
        setIsLoading(false)
      },
      () => {

      },
      bookingId
    )
  }, [])

  return (
    <div className="page-user-outgoing-payments">
      <h1>Uitbetalingen {bookingId && ' voor boeking'}</h1>
      <div className="row buttons">
        {bookingId ?
          <Button
            label="Terug naar boeking"
            link={'/user/boeking/' + bookingId}
          />
          :
          <>
            <Button
              label="Boekingsoverzicht"
              link={'/user/boekingen'}
            />
            <Button
              label="Betalingsoverzicht"
              link={'/user/betalingen'}
            />
          </>
        }

      </div>

      {isLoading ?
        <Loading/>
        :
        <div className="outgoing-payments">
          {outgoingPayments && !!outgoingPayments.length
            ? outgoingPayments.map((outgoingPayment, i) => {
              return (<OutgoingPaymentRow key={i} outgoingPayment={outgoingPayment} showLinksToBooking={!bookingId}/>)
            })
            : <p>Nog geen uitbetalingen</p>
          }
        </div>
      }
    </div>
  )
}

export default UserOutgoingPayments
